export const Breadcrumb = theme => ({
  MuiBreadcrumbs: {
    styleOverrides: {
      root: {
        padding: theme.spacing(1),
      },
    }
  },
});
